<script setup>
import { ref } from 'vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['create-from-template']);

const dialogRef = ref(null);

const templates = [
  {
    id: 'sales-b2b',
    name: 'Vendas B2B',
    description: 'Pipeline para vendas corporativas',
    icon: 'i-lucide-building-2',
    iconBg: 'bg-n-blue-3',
    iconColor: 'text-n-blue-11',
    stages: ['Prospeccao', 'Qualificacao', 'Proposta', 'Negociacao', 'Fechamento'],
  },
  {
    id: 'sales-b2c',
    name: 'Vendas B2C',
    description: 'Pipeline para vendas diretas ao consumidor',
    icon: 'i-lucide-shopping-bag',
    iconBg: 'bg-n-green-3',
    iconColor: 'text-n-green-11',
    stages: ['Lead', 'Contato', 'Demonstracao', 'Proposta', 'Venda'],
  },
  {
    id: 'recruitment',
    name: 'Recrutamento',
    description: 'Processo de selecao de candidatos',
    icon: 'i-lucide-users',
    iconBg: 'bg-n-violet-3',
    iconColor: 'text-n-violet-11',
    stages: ['Triagem', 'Entrevista RH', 'Teste Tecnico', 'Entrevista Final', 'Proposta'],
  },
  {
    id: 'real-estate',
    name: 'Imobiliario',
    description: 'Vendas de imoveis',
    icon: 'i-lucide-home',
    iconBg: 'bg-n-amber-3',
    iconColor: 'text-n-amber-11',
    stages: ['Captacao', 'Visita', 'Proposta', 'Negociacao', 'Documentacao', 'Fechamento'],
  },
];

const selectTemplate = template => {
  emit('create-from-template', template);
};

const open = () => {
  dialogRef.value?.open();
};

const close = () => {
  dialogRef.value?.close();
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    title="Escolha um Template"
    :show-confirm-button="false"
    :show-cancel-button="false"
    width="2xl"
  >
    <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
      <button
        v-for="template in templates"
        :key="template.id"
        class="p-4 text-left border border-n-weak rounded-lg hover:border-n-brand hover:bg-n-alpha-1 transition-colors group"
        @click="selectTemplate(template)"
      >
        <div class="flex items-start gap-3">
          <!-- Icon -->
          <div
            class="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center transition-colors"
            :class="template.iconBg"
          >
            <span class="text-xl" :class="[template.icon, template.iconColor]" />
          </div>

          <!-- Info -->
          <div class="flex-1 min-w-0">
            <h4 class="text-sm font-bold text-n-slate-12 mb-1">
              {{ template.name }}
            </h4>
            <p class="text-xs text-n-slate-11 mb-2">
              {{ template.description }}
            </p>

            <!-- Stages Preview -->
            <div class="flex flex-wrap gap-1">
              <span
                v-for="(stage, index) in template.stages.slice(0, 3)"
                :key="index"
                class="text-[10px] px-1.5 py-0.5 bg-n-slate-3 text-n-slate-11 rounded"
              >
                {{ stage }}
              </span>
              <span
                v-if="template.stages.length > 3"
                class="text-[10px] px-1.5 py-0.5 bg-n-slate-3 text-n-slate-11 rounded"
              >
                +{{ template.stages.length - 3 }}
              </span>
            </div>
          </div>
        </div>
      </button>
    </div>
  </Dialog>
</template>
